<template>
    <div v-if="post" class="post">
        <div v-if="$store.state.loggedIn && $store.state.user.role === 'admin'" class="post__edit">
            <router-link :to="{name:'Edit', params:{collection:'posts', id:post.slug}}" class="btn btn--orange">
                Edit Post
            </router-link>
        </div>
        <router-link :to="{name:'Community'}" class="post__back">
            <Svg className="post__back--svg" icon="left-arrow"></Svg>
            {{t('back')}}
        </router-link>
        <div class="post__date">
            {{moment(post.createdAt).locale($store.state.language).fromNow()}}
        </div>
        <post-content :post="post" :countComments="comments.length" > </post-content>
        <div class="post__reaction">
            <post-reaction  v-for="reaction in post.reactions" :key="reaction.svg" :reaction="reaction" :idPost="post._id"></post-reaction>
        </div>
        <post-comment-form collection='Post' :reference="post._id" @newCommentPost="updateComments"></post-comment-form>
        <post-answers :comments="comments" collection='Post'></post-answers>
        <post-similar :postId="post._id"></post-similar>
    </div>


</template>

<script>



import axios from 'axios';
import { useRoute, useRouter } from 'vue-router';
import { onMounted, ref, watch } from 'vue';

import moment from 'moment';

import { useI18n } from 'vue-i18n';


import PostReaction from '@/components/post/PostReaction';
import PostContent from '@/components/post/PostContent';
import PostCommentForm from '@/components/post/PostCommentForm';
import PostAnswers from '@/components/post/PostAnwsers';
import PostSimilar from '@/components/post/PostSimilar';
import Svg from '@/components/utils/Svg';
import { useStore } from 'vuex';

import en from "@/locales/en/post/post.json"
import fr from "@/locales/fr/post/post.json"

export default {
    components: { PostAnswers, PostContent,PostCommentForm, PostReaction, PostSimilar, Svg},
    props:['slug'],
    setup(props){
        const route = useRoute(); 
        const router = useRouter();
        const postSlug = ref(route.params.slug);
        const post = ref(null);
        const comments = ref([]);
        const store = useStore();

        const {t, locale}  = useI18n({
			messages:{
              en: en,
              fr: fr
            }
		})

        onMounted(() => getPost())

        watch(() => route.params.slug, (slug) => {
            if(slug){
                postSlug.value = slug
                getPost();
            }
            
        })

        const getPost = async () => {
            try{
                const res = await axios({
                    method:'GET',
                    url:'posts/'+postSlug.value
                })

                post.value = res.data.post;
                comments.value =  res.data.comments;

                post.value.reactions = generateReactions(post.value.reaction);
                const postTitle = post.value.locales && post.value.locales[store.state.language] && post.value.locales[store.state.language].title ? post.value.locales[store.state.language].title: post.value.title;
                const postMetaDescription = post.value.locales && post.value.locales[store.state.language] && post.value.locales[store.state.language].description ? post.value.locales[store.state.language].description : post.value.description;

                document.title = document.title.replace('postTitle', postTitle); //Page title

                if(postMetaDescription) document.querySelector('meta[name="description"]').setAttribute("content", postMetaDescription.substring(0, 155));
                
            }catch(err){
                console.log(err);
                if(err.response && err.response.status === 500){
                    router.push({path:'/pagenotfound'});
                }
            }
        }

        const generateReactions = (reaction) => {
            let reactions = [
                {
                    name:"endorse",
                    svg: "endorse"
                },
                {
                    name:'love',
                    svg: "love"
                },
                {
                    name:"fun",
                    svg:"fun"
                },
                {
                    name:"wow",
                    svg:"wow"
                },
                {
                    name:"sad",
                    svg:"sad"
                }
            ];
                
            for(let r of reactions){
                if(!r.likes) r.likes = [];
                if(reaction){
                    for(let reac of reaction){
                        if(r.name === reac.name){
                            r.likes.push(reac.user);
                        }
                    }
                }
            }
            return reactions
        }

        const updateComments = (value) => {
            comments.value.push(value);
        }

        return {comments, moment, post,  t, updateComments}
    }

}
</script>

<style lang="scss">
@import '@/style/main';

$article-max-width: 80rem;

.post{
    position: relative;
    max-width:$article-max-width;
    margin: $nav-height + 2rem auto 0 auto;
    display: flex;
    flex-direction: column;

    @include respond(phone){
        padding: 2rem 3rem;
    }

    &__back{
        display: flex;
        align-items: center;
        margin: 2rem 0;
        align-self: flex-start;

        text-decoration: none;
        color: inherit;

        text-transform: uppercase;
        font-size: 1.4rem;
        font-weight: 700;
        letter-spacing: .2rem;

        @include hoverUnderline;

        &--svg{
            @include svg(2rem);
            margin-right: 1.6rem;
        }
    }

    &__date{
        text-transform: uppercase;
        margin-bottom: 2rem;
        letter-spacing: .1rem;
        font-size: 1.4rem;
    }

    &__reaction{
        margin: 0 auto;
        display: flex;
        justify-content: center;
    }

    &__edit{
        position: absolute;
        top: 0;
        right: 0;
        width: 20rem;
    }

}

</style>